module.exports = __webpack_public_path__ + "38f41ccb7106c006a5350010e157e239.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-64@2x.png
// module id = 529
// module chunks = 0